import React from 'react'

import { ProductImage } from 'components/_new/ui'

import s from './Product.scss'


export type ProductProps = SkipAMonthModal.Product

const Product: React.FunctionComponent<ProductProps> = (props) => {
  const { name, brand, image } = props

  return (
    <ProductImage
      className={s.product}
      src={image}
      alt={`${name} by ${brand}`}
      height={100}
      resizeBy="width"
      imagePercentage={100}
      dataTestId="skipAMonthProduct"
    />
  )
}


export default Product
